import React from 'react';
import HomeSection from '../../components/HomeSection/HomeSection';

const Home: React.FC = () => {
  return (
    <div>
      <HomeSection />
    </div>
  );
};

export default Home;